module.exports = __webpack_public_path__ + "static/media/calendar.e93c1086.png";